export const userItemPath = 'user';
export const userItemLoginPath = 'userLogin';

export interface UserItemObject {
	name: string;
	password: string;
};